import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "grid grid-cols-12 gap-4" }
const _hoisted_3 = { class: "col-span-12 lg:col-span-4" }
const _hoisted_4 = { class: "col-span-12 md:col-span-6 lg:col-span-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, " Symmetric and PrimeDAO areannounced a partnership between the two DAOs that will align our interests, bring a fair and efficient token launchpad to Celo and Gnosis. ", -1)
const _hoisted_6 = {
  style: {"max-height":"400px","overflow":"auto !important"},
  class: "col-span-12 md:col-span-6 lg:col-span-4"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "twitter-timeline",
    href: "https://twitter.com/0xSymmetric?ref_src=twsrc%5Etfw"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalLink = _resolveComponent("BalLink")!
  const _component_BalCard = _resolveComponent("BalCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.$t('featuredProtocol')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_BalCard, {
          title: "What’s coming with Symmetric v2?",
          imgSrc: "https://miro.medium.com/max/1200/0*IB8Epue3yfd3NHMq.jpeg",
          class: "transition-shadow hover:shadow-xl",
          hFull: "",
          growContent: ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_BalLink, {
              href: _ctx.EXTERNAL_LINKS.Symmetric.Medium,
              external: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('viewAndReadMoreCard1')), 1),
                _createVNode(_component_BalIcon, {
                  name: "arrow-up-right",
                  size: "sm",
                  class: "ml-1"
                })
              ]),
              _: 1
            }, 8, ["href"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('cardOneText')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_BalCard, {
          title: "Symmetric-PrimeDAO Partnership",
          imgSrc: "https://miro.medium.com/max/1400/0*GKnpKS01rfdrqoi8",
          class: "transition-shadow hover:shadow-xl",
          hFull: "",
          growContent: ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_BalLink, {
              href: _ctx.EXTERNAL_LINKS.Symmetric.PrimeDaoMedium,
              external: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('viewAndReadMoreCard2')), 1),
                _createVNode(_component_BalIcon, {
                  name: "arrow-up-right",
                  size: "sm",
                  class: "ml-1"
                })
              ]),
              _: 1
            }, 8, ["href"])
          ]),
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_BalCard, {
          class: "transition-shadow hover:shadow-xl",
          imgSrc: "https://pbs.twimg.com/profile_banners/1384941129796395010/1640465820/1500x500"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ])
    ])
  ]))
}